import { IVRScreen } from "@/modules/ivr/views/ivr-screen";
import type { CheckoutSession } from "@/types";

interface IVRPageProps {
  onCheckoutFetched: (session: CheckoutSession) => void;
}

export function IVRPage({ onCheckoutFetched }: IVRPageProps) {
  return <IVRScreen onSessionFetched={onCheckoutFetched} />;
}
